module.exports = __webpack_public_path__ + "img/1a4b4dd.svg";